<template>
  <b-modal ref="modal" size="lg" lazy no-close-on-backdrop hide-header-close>
    <template slot="modal-header">
      <h2>{{ $t('project.editProject') }}</h2>
    </template>
    <template slot="default">
      <b-form novalidate @submit="$event.preventDefault(), onSubmitClick()">
        <b-container>
          <b-form-group :label="$t('project.name')" class="text-left">
            <b-form-input
              type="text"
              v-validate="'required'"
              :data-vv-as="$t('project.name')"
              data-vv-name="projectname"
              v-model="project.name"
            />
            <span>{{errors.first('projectname')}}</span>
          </b-form-group>
          <b-form-group :label="$t('project.description')" class="text-left">
            <b-form-textarea v-model="project.description" rows="3" no-resize/>
          </b-form-group>
        </b-container>
      </b-form>
    </template>
    <template slot="modal-footer">
      <b-button @click="onCancelClick">{{ $t('cancel')}}</b-button>
      <b-button :disabled="submitValid" @click="onSubmitClick" variant="primary">{{ $t('save')}}</b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      project: {},
      oldValue: {
        name: null,
        description: null
      }
    };
  },
  components: {},
  computed: {
    submitValid() {
      var valid =
        this.oldValue.description != this.project.description ||
        this.oldValue.name != this.project.name;
      return !valid;
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showModal: async function() {
      this.project = {
        name: this.$store.state.projects.project.name,
        description: this.$store.state.projects.project.description
      };

      this.$refs.modal.show();
      this.oldValue.name = this.project.name;
      this.oldValue.description = this.project.description;
    },
    onCancelClick() {
      this.$emit("cancel");
    },
    onSubmitClick: async function() {
      if (await this.$validator.validateAll()) {
        await this.$store.dispatch("projects/changeProjectInfo", this.project)
        this.$refs.modal.hide();
        this.$router.push(this.$route.path);
      }
    }
  },
  mounted() {
    if (this.show) this.showModal();
    var self = this;
    window.addEventListener("keyup", function(event) {
      // If  ESC key was pressed...
      if (event.keyCode === 27) {
        // try close your dialog
        self.onCancelClick();
      }
    });
  },
  watch: {
    show(val) {
      if (val) this.showModal();
      else {
        this.$refs.modal.hide();
      }
    }
  }
};
</script>
